<div class="container page-top mb-5">
  <h1 class="my-5">Order History</h1>
  <p class="mb-4">
    Click on the order number to see your receipt and the serial numbers or
    license files. Your order history will be available as long as you are an
    active student or active employee.
  </p>
  <app-order-search (searchEvent)="handleSearch($event)"></app-order-search>
  <div *ngIf="ordersToView; else emptyMessage">
    <div class="h2 py-5" *ngIf="isSearching">
      Search Results
    </div>
    <div *ngFor="let cwi of currentPage.data" class="my-4">
      <app-past-order [cart]="cwi.cart" [items]="cwi.lineItems"></app-past-order>
    </div>
    <div *ngIf="hasEmptySearchResults" class="text-center">
      <span class="fst-italic h5">
        There are no matches to search criteria
      </span>
    </div>
    <app-page [page]="currentPage"
              (requestedPage)="handlePageSelect($event)">
    </app-page>
  </div>
  <ng-template #emptyMessage>
    <div id="emptyMessageDiv" *ngIf="pulledSomeOrders && !ordersToView">
      <h2 class="mt-4">You have no orders to view.</h2>
    </div>
  </ng-template>
</div>
